<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right page-tb-consumption-terminal">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表：表头与内容统一居中。最后修改：2026-08-07 -->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" ref="table" class="custom-tbl tb-consumption-terminal-table"
        height="100%" style="width: 100%" @selection-change="handleSelectionChange" @row-click="handleTableRowClick">
        <el-table-column type="selection" width="46" align="center"> </el-table-column>

        <el-table-column label="终端" min-width="140" align="center">
          <template slot-scope="{ row }">
            <div class="cell-block">
              <div class="cell-main" :title="terminalPrimary(row)">{{ terminalPrimary(row) }}</div>
              <div v-if="terminalShowTwoLines(row)" class="cell-meta" :title="row.KqTerminalId">{{ row.KqTerminalId }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="模式" min-width="160" align="center">
          <template slot-scope="{ row }">
            <div v-for="m in [getTbConsumptionModeMeta(row)]" :key="'cm-' + row.Id" class="tag-row">
              <template v-if="m.modeLabel">
                <el-tag :type="m.modeType" size="mini" effect="light" disable-transitions>{{ m.modeLabel }}</el-tag>
                <el-tag v-if="m.subsidyLabel || m.amountLabel" type="info" effect="light" size="mini"
                  class="mode-tag-sub" disable-transitions>{{ consumptionModeSubText(m) }}</el-tag>
              </template>
              <span v-else class="cell-meta">—</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="专项优先" width="100" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-if="showSubsidyScopeFields(row.TouchTypeDirection)"
              :value="rowPrioritizeSubsidy(row)"
              :disabled="!!row._prioritizeSaving"
              inactive-color="#dcdfe6"
              @change="(v) => onInlinePrioritizeChange(row, v)" />
            <span v-else class="cell-meta">—</span>
          </template>
        </el-table-column>

        <el-table-column label="部门 / 位置" min-width="150" align="center">
          <template slot-scope="{ row }">
            <div class="cell-block">
              <div class="cell-main" :title="deptLocationPrimary(row)">{{ deptLocationPrimary(row) }}</div>
              <div v-if="deptLocationShowTwoLines(row)" class="cell-meta" :title="row.InstallAddress || ''">{{ row.InstallAddress || '未填位置' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="IsOnLine" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsOnLine == 1 ? 'success' : 'info'" size="mini" effect="light"
              disable-transitions>{{ scope.row.IsOnLine == 1 ? "在线" : "离线" }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="TerminalDesc" label="备注" min-width="100" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间" min-width="160" align="center" show-overflow-tooltip>
        </el-table-column>

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑终端信息" :visible.sync="editFormVisible" :close-on-click-modal="false"
        destroy-on-close width="720px" append-to-body>
        <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm" class="terminal-dialog-form">

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="终端标识" prop="KqTerminalId">
                <el-input v-model="editForm.KqTerminalId" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终端名称" prop="TerminalName">
                <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="安装位置" prop="InstallAddress">
                <el-input v-model="editForm.InstallAddress" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消费模式" prop="TouchTypeDirection">
                <el-select v-model="editForm.TouchTypeDirection" placeholder="请选择终端模式" style="width: 100%">
                  <el-option label="自由模式" value="1"></el-option>
                  <el-option label="限次模式" value="2"></el-option>
                  <el-option label="时间段消费模式" value="3"></el-option>
                  <el-option label="固定金额模式" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="editForm.TouchTypeDirection === '1' || editForm.TouchTypeDirection === '3'">
            <el-col :span="12">
              <el-form-item label="补贴类型" prop="SubsidyMode">
                <el-select v-model="editForm.SubsidyMode" placeholder="请选择补贴类型" style="width: 100%">
                  <el-option label="无限制" value=""></el-option>
                  <el-option label="不启用补贴" value="3"></el-option>
                  <el-option label="启用学生补贴" value="1"></el-option>
                  <el-option label="启用老师补贴" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="showSubsidyScopeFields(editForm.TouchTypeDirection)" :gutter="16">
            <el-col :span="12">
              <el-form-item label="优先扣专项">
                <el-switch v-model="editForm.prioritizeSubsidyBalance" :active-value="true" :inactive-value="false" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="专项分组范围">
                <el-select :key="'edit-sg-' + editSubsidySelectKey"
                  v-model="editForm.subsidyGroupIdList" multiple clearable style="width:100%"
                  placeholder="不选表示全部分组">
                  <el-option v-for="g in consumptiveGroupOptions" :key="g.Id" :label="g.GroupName" :value="g.Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="editForm.TouchTypeDirection == '4'">
            <el-col :span="12">
              <el-form-item class="terminal-form-item--fixed-amount-label">
                <template slot="label">
                  <span class="terminal-fixed-amount-label">固定金额模式<br />金额</span>
                </template>
                <el-input-number v-model="editForm.InstallPosition" :min="1" :step="1" style="width: 100%" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item label="设备说明">
                <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增终端信息" :visible.sync="addFormVisible" :close-on-click-modal="false"
        destroy-on-close width="720px" append-to-body>
        <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm"
          class="demo-form-inline terminal-dialog-form">

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="终端标识" prop="KqTerminalId">
                <el-input v-model="addForm.KqTerminalId" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终端名称" prop="TerminalName">
                <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="安装位置" prop="InstallAddress">
                <el-input v-model="addForm.InstallAddress" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终端模式" prop="TouchTypeDirection">
                <el-select v-model="addForm.TouchTypeDirection" placeholder="请选择终端模式" style="width: 100%">
                  <el-option label="自由模式" value="1"></el-option>
                  <el-option label="限次模式" value="2"></el-option>
                  <el-option label="时间段消费模式" value="3"></el-option>
                  <el-option label="固定金额模式" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="addForm.TouchTypeDirection === '1' || addForm.TouchTypeDirection === '3'">
            <el-col :span="12">
              <el-form-item label="补贴类型" prop="SubsidyMode">
                <el-select v-model="addForm.SubsidyMode" placeholder="请选择补贴类型" style="width: 100%">
                  <el-option label="无限制" value=""></el-option>
                  <el-option label="不启用补贴" value="3"></el-option>
                  <el-option label="启用学生补贴" value="1"></el-option>
                  <el-option label="启用老师补贴" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="showSubsidyScopeFields(addForm.TouchTypeDirection)" :gutter="16">
            <el-col :span="12">
              <el-form-item label="优先扣专项">
                <el-switch v-model="addForm.prioritizeSubsidyBalance" :active-value="true" :inactive-value="false" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="专项分组范围">
                <el-select :key="'add-sg-' + addSubsidySelectKey"
                  v-model="addForm.subsidyGroupIdList" multiple clearable style="width:100%"
                  placeholder="不选表示全部分组">
                  <el-option v-for="g in consumptiveGroupOptions" :key="g.Id" :label="g.GroupName" :value="g.Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="addForm.TouchTypeDirection == '4'">
            <el-col :span="12">
              <el-form-item class="terminal-form-item--fixed-amount-label">
                <template slot="label">
                  <span class="terminal-fixed-amount-label">固定金额模式<br />金额</span>
                </template>
                <el-input-number v-model="addForm.InstallPosition" :min="1" :step="1" style="width: 100%" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item label="设备说明">
                <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getKqtDeviceTerminalListPage, removeKqtDeviceTerminal, editKqtDeviceTerminal, addKqtDeviceTerminal } from '../../api/modules/attendance';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getSubsidyStudentGroupList } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane';
import { normalizeDeptId } from '../../utils/deptCascaderProps';

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {},
      BaseApiUrl: BaseApiUrl, // 网络前缀
      searchList: [
        {
          label: '终端名称',
          key: 'name',
          width: '140px',
        },
        {
          label: '序列号',
          key: 'kqTerminalId',
          width: '160px',
          placeholder: '终端标识/序列号'
        },
        {
          label: '消费模式',
          key: 'consumptionMode',
          type: 'select',
          width: '130px',
          options: [{
            label: '全部',
            value: ''
          }, {
            label: '自由模式',
            value: '1'
          }, {
            label: '限次模式',
            value: '2'
          }, {
            label: '时间段消费模式',
            value: '3'
          }, {
            label: '固定金额模式',
            value: '4'
          }]
        },
        {
          label: '状态',
          key: 'isOnLine',
          type: 'select',
          width: '110px',
          options: [
            { label: '全部', value: '' },
            { label: '在线', value: '1' },
            { label: '离线', value: '0' }
          ]
        },
      ],
      users: [],
      options: [],
      total: 0,
      buttonList: [],
      page: 1,
      listLoading: false,
      multipleSelection: [],
      editFormVisible: false, // 编辑界面是否显示
      editLoading: false,
      editFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
      },
      // 编辑界面数据
      editForm: {
        Id: 0,
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        InstallPosition: "",
        SubsidyMode: "",
        Dids: [],
        DepartmentId: 0,
        TerminalTypeId: "6",
        InstallAddress: "",
        prioritizeSubsidyBalance: false,
        subsidyGroupIdList: []
      },
      isResouceShow: 0,
      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
      },
      // 新增界面数据
      addForm: {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "1",
        TerminalDesc: "",
        InstallPosition: "",
        SubsidyMode: "",
        Dids: [],
        DepartmentId: 0,
        TerminalTypeId: "6",
        InstallAddress: "",
        prioritizeSubsidyBalance: false,
        subsidyGroupIdList: []
      },
      consumptiveGroupOptions: [],
      DepartmentId: 0,
      editSubsidySelectKey: 0,
      addSubsidySelectKey: 0
    };
  },

  methods: {
    parseConsumptiveGroupIdList(s) {
      if (s == null || s === '') return [];
      return String(s)
        .split(',')
        .map((x) => String(x).trim())
        .filter((x) => x.length > 0);
    },
    alignSubsidyGroupIdsToOptions(parsedIds) {
      const opts = this.consumptiveGroupOptions || [];
      const ids = parsedIds || [];
      if (!opts.length || !ids.length) return [];
      const out = [];
      for (const p of ids) {
        const hit = opts.find((g) => {
          const gid = g.Id != null ? g.Id : g.id;
          return String(gid) === String(p);
        });
        if (hit) out.push(hit.Id != null ? hit.Id : hit.id);
      }
      return out;
    },
    async loadConsumptiveGroupOptions(deptId) {
      const id = normalizeDeptId(deptId) || normalizeDeptId(this.DepartmentId);
      if (!id) {
        this.consumptiveGroupOptions = [];
        return;
      }
      try {
        const res = await getSubsidyStudentGroupList({ departmentId: id });
        if (res.data && res.data.success)
          this.consumptiveGroupOptions = res.data.response || [];
        else
          this.consumptiveGroupOptions = [];
      } catch (e) {
        this.consumptiveGroupOptions = [];
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    terminalShowTwoLines(row) {
      const id = (row.KqTerminalId || '').trim();
      const name = (row.TerminalName || '').trim();
      if (!id && !name) return false;
      if (!id || !name) return false;
      return id !== name;
    },
    /** 终端主行：优先名称，否则编号 */
    terminalPrimary(row) {
      const id = (row.KqTerminalId || '').trim();
      const name = (row.TerminalName || '').trim();
      return name || id || '—';
    },
    deptLocationShowTwoLines(row) {
      const d = (row.DepartmentName || '').trim();
      const a = (row.InstallAddress || '').trim();
      return !!(d && a && a !== d);
    },
    /** 部门/位置主行 */
    deptLocationPrimary(row) {
      const d = (row.DepartmentName || '').trim();
      const a = (row.InstallAddress || '').trim();
      if (d) return d;
      return a || '—';
    },
    getTbConsumptionModeMeta(row) {
      const td = row.TouchTypeDirection == null ? '' : String(row.TouchTypeDirection);
      const sm = row.SubsidyMode;
      let subsidyLabel = '';
      if (td === '1' || td === '3' || td === '5') {
        if (sm === '' || sm == null) subsidyLabel = '无限制';
        else if (sm === '1') subsidyLabel = '学生补贴';
        else if (sm === '2') subsidyLabel = '老师补贴';
        else if (sm === '3') subsidyLabel = '不启用补贴';
      }
      if (td === '1') {
        return { modeLabel: '自由模式', modeType: 'success', subsidyLabel, amountLabel: '' };
      }
      if (td === '2') {
        return { modeLabel: '限次模式', modeType: 'info', subsidyLabel: '', amountLabel: '' };
      }
      if (td === '3') {
        return { modeLabel: '时间段消费模式', modeType: 'warning', subsidyLabel, amountLabel: '' };
      }
      if (td === '4') {
        const ip = row.InstallPosition;
        const amountLabel = ip ? `${ip} 元` : '';
        return { modeLabel: '固定金额模式', modeType: 'danger', subsidyLabel: '', amountLabel };
      }
      if (td === '5') {
        return { modeLabel: '订餐模式', modeType: 'success', subsidyLabel, amountLabel: '' };
      }
      return { modeLabel: '', modeType: 'info', subsidyLabel: '', amountLabel: '' };
    },
    consumptionModeSubText(m) {
      return [m.subsidyLabel, m.amountLabel].filter(Boolean).join(' ');
    },
    rowPrioritizeSubsidy(row) {
      return row.prioritizeSubsidyBalance === true || row.prioritizeSubsidyBalance === 1
        || row.PrioritizeSubsidyBalance === true || row.PrioritizeSubsidyBalance === 1;
    },
    showSubsidyScopeFields(touchTypeDirection) {
      return String(touchTypeDirection || '') !== '2';
    },
    buildTerminalPutPayloadFromListRow(row, prioritizeSubsidyBalance) {
      const para = Object.assign({}, row);
      delete para._prioritizeSaving;
      para.PrioritizeSubsidyBalance = !!prioritizeSubsidyBalance;
      const gid = row.subsidyGroupIds != null && row.subsidyGroupIds !== ''
        ? String(row.subsidyGroupIds)
        : (row.SubsidyGroupIds != null ? String(row.SubsidyGroupIds) : '');
      para.SubsidyGroupIds = gid;
      if (Array.isArray(para.Dids) && para.Dids.length > 0) {
        para.DepartmentId = para.Dids[para.Dids.length - 1];
      }
      return para;
    },
    onInlinePrioritizeChange(row, val) {
      this.$set(row, '_prioritizeSaving', true);
      const para = this.buildTerminalPutPayloadFromListRow(row, val);
      editKqtDeviceTerminal(para).then((res) => {
        if (util.isEmt.format(res)) {
          this.$set(row, '_prioritizeSaving', false);
          return;
        }
        this.$set(row, '_prioritizeSaving', false);
        if (res.data.success) {
          this.$set(row, 'prioritizeSubsidyBalance', val);
          this.$set(row, 'PrioritizeSubsidyBalance', val);
          this.$message.success(res.data.msg || '已更新');
        } else {
          this.$message.error(res.data.msg || '更新失败');
          this.$forceUpdate();
        }
      }).catch(() => {
        this.$set(row, '_prioritizeSaving', false);
        this.$message.error('保存失败');
        this.$forceUpdate();
      });
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value;
      this.handleQuery();
    },

    /** 点击行切换勾选（可多选、再点同一行取消） */
    handleTableRowClick(row, column, event) {
      if (!row || !this.$refs.table) return;
      const t = event && event.target;
      if (t && typeof t.closest === 'function') {
        if (t.closest('.el-checkbox')) return;
        if (t.closest('.el-switch')) return;
        if (t.closest('button') || t.closest('.el-button')) return;
      }
      const selected = (this.multipleSelection || []).some((r) => r.Id === row.Id);
      this.$refs.table.toggleRowSelection(row, !selected);
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search;
      } else {
        this.filters = {
          key: item.search,
        };
      }
      this[item.Func].apply(this, item);
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    // 获取设备列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: "6"
      };
      this.listLoading = true;

      testapi();
      getKqtDeviceTerminalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    // 删除
    handleDel() {
      var rows = this.multipleSelection;
      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择要删除的一行数据！',
          type: 'error',
        });
        return;
      }

      var row = rows[0];

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeKqtDeviceTerminal(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    // 显示编辑界面
    async handleEdit() {
      var rows = this.multipleSelection;
      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        });
        return;
      }
      var row = rows[0];
      this.options = [];
      await this.loadConsumptiveGroupOptions(row.DepartmentId);
      const parsed = this.parseConsumptiveGroupIdList(row.subsidyGroupIds || row.SubsidyGroupIds);
      const aligned = this.alignSubsidyGroupIdsToOptions(parsed);
      this.editForm = Object.assign({}, row);
      // 优先使用当前终端绑定的所属学校ID，若无则使用当前页面统一选中的 ID 兜底
      this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId;
      this.$set(this.editForm, 'prioritizeSubsidyBalance', this.rowPrioritizeSubsidy(row));
      this.editFormVisible = true;
      await this.$nextTick();
      this.$set(this.editForm, 'subsidyGroupIdList', aligned.slice());
      await this.$nextTick();
      this.editSubsidySelectKey += 1;
    },
    // 显示新增界面
    async handleAdd() {
      // 限制：必须先在左侧选择具体的学校机构才能进行新增
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.options = [];
      await this.loadConsumptiveGroupOptions(this.DepartmentId);
      this.addForm = {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "1",
        TerminalDesc: "",
        InstallPosition: "",
        SubsidyMode: "",
        Dids: [],
        DepartmentId: this.DepartmentId, // 直接使用当前页面统一选中的学校ID
        TerminalTypeId: "6",
        InstallAddress: "",
        prioritizeSubsidyBalance: false,
        subsidyGroupIdList: []
      };
      this.addFormVisible = true;
      await this.$nextTick();
      this.addSubsidySelectKey += 1;
    },
    // 编辑提交
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);
            delete para.subsidyGroupIdList;
            delete para.prioritizeSubsidyBalance;
            if (String(this.editForm.TouchTypeDirection || '') === '2') {
              para.PrioritizeSubsidyBalance = false;
              para.SubsidyGroupIds = '';
            } else {
              para.PrioritizeSubsidyBalance = !!this.editForm.prioritizeSubsidyBalance;
              para.SubsidyGroupIds = (this.editForm.subsidyGroupIdList || [])
                .map((x) => String(x == null ? '' : x).trim())
                .filter((x) => x.length > 0)
                .join(',');
            }

            editKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    // 新增提交
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            delete para.subsidyGroupIdList;
            delete para.prioritizeSubsidyBalance;
            if (String(this.addForm.TouchTypeDirection || '') === '2') {
              para.PrioritizeSubsidyBalance = false;
              para.SubsidyGroupIds = '';
            } else {
              para.PrioritizeSubsidyBalance = !!this.addForm.prioritizeSubsidyBalance;
              para.SubsidyGroupIds = (this.addForm.subsidyGroupIdList || [])
                .map((x) => String(x == null ? '' : x).trim())
                .filter((x) => x.length > 0)
                .join(',');
            }

            addKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.mode-tag-sub {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  min-height: 40px;
  padding: 2px 0;
  min-width: 0;
}

.cell-main {
  color: #303133;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-align: center;
}

.cell-meta {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-align: center;
}

.tag-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}

/* 固定金额：标签固定两行，避免 label 区过窄时「金」「额」被拆开 */
.terminal-dialog-form>>>.terminal-form-item--fixed-amount-label .el-form-item__label {
  white-space: normal;
  line-height: 1.35;
  height: auto;
}

.terminal-dialog-form>>>.terminal-fixed-amount-label {
  display: inline-block;
  text-align: right;
}

.page-tb-consumption-terminal>>>.toolbar {
  margin-bottom: 16px;
}

.page-tb-consumption-terminal>>>.toolbar .el-form--inline>span {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 14px;
}

.page-tb-consumption-terminal>>>.toolbar .el-form--inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 8px;
  column-gap: 0;
}

.page-tb-consumption-terminal>>>.toolbar .el-form--inline .el-form-item {
  margin-bottom: 0;
  margin-right: 10px;
  vertical-align: middle;
}

.page-tb-consumption-terminal>>>.toolbar .el-form-item:last-child {
  margin-right: 0;
}

.tb-consumption-terminal-table >>> .el-table__body tr {
  cursor: pointer;
}

.tb-consumption-terminal-table >>> .el-table td,
.tb-consumption-terminal-table >>> .el-table th {
  vertical-align: middle;
}

.tb-consumption-terminal-table >>> .el-table .cell {
  line-height: 20px;
  padding-left: 12px;
  padding-right: 12px;
}

.tb-consumption-terminal-table >>> .el-tag--mini {
  height: 22px;
  line-height: 20px;
  padding: 0 8px;
}
</style>